import DebtorScreen from './DebtorScreen';

export default DebtorScreen;
